import React from 'react';
import { Box, Typography } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

/**
 * A simple drop zone visual component
 * Used as a placeholder inside react-dropzone areas
 * Migrated from vardogyir-ui/DropZone.js
 */
const DropZone = () => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      color: 'text.secondary',
      '&:hover': {
        color: 'text.primary',
        borderColor: 'text.primary',
      },
      bgcolor: 'action.hover',
      borderRadius: '3px',
      width: '100%',
      height: 209,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box sx={{ textAlign: 'center' }}>
      <CloudUploadIcon sx={{ fontSize: 24, color: 'inherit' }} />
      <Typography
        sx={{
          fontFamily: 'Open Sans',
          lineHeight: 1,
          fontStyle: 'normal',
          fontWeight: 'normal',
          fontSize: 12,
          m: 1,
        }}
      >
        Drop file here
      </Typography>
    </Box>
  </Box>
);

export default DropZone;
